import { GraphqlPagination, InfiniteScrollGridComponents } from '@components/infiniteScroll';
import { Graph } from '@generated/graphql';
import { VirtuosoGrid } from 'react-virtuoso';
import { GraphsGridViewPreview } from './GraphsGridViewPreview';

interface GraphsGridViewProps {
  pagination: GraphqlPagination<Graph>;
  refetch: VoidFunction;
}

export const GraphsGridView = ({
  pagination: { data: graphs, fetchMore },
  refetch,
}: GraphsGridViewProps) => {
  const item = (_index, graph: Graph) => <GraphsGridViewPreview graph={graph} refetch={refetch} />;

  return (
    <VirtuosoGrid
      totalCount={graphs.length}
      overscan={400}
      endReached={fetchMore}
      components={InfiniteScrollGridComponents}
      data={graphs}
      itemContent={item}
    />
  );
};
